import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
  fill?: string;
}

export const SourceCodeIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99967 14.6654C11.6816 14.6654 14.6663 11.6806 14.6663 7.9987C14.6663 4.3168 11.6816 1.33203 7.99967 1.33203C4.31778 1.33203 1.33301 4.3168 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M10.667 6.66797L11.4847 7.37277C11.8285 7.66904 12.0003 7.81724 12.0003 8.0013C12.0003 8.18537 11.8285 8.33357 11.4847 8.62984L10.667 9.33464"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33333 6.66797L4.51564 7.37277C4.17188 7.66904 4 7.81724 4 8.0013C4 8.18537 4.17188 8.33357 4.51564 8.62984L5.33333 9.33464"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66634 6L7.33301 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
